export default () => {

	const ua = window.navigator.userAgent;
	return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
};


// WEBPACK FOOTER //
// ./src/utils/isIe.js